import type { FunctionComponent } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AlbInput } from "@/components/Forms/albInput";
import type { useConfirmResetForm } from "../../ForgotPassword/ConfirmResetForm";

import { PasswordValidator } from "../../PasswordValidator";

type Props = {
  form: ReturnType<typeof useConfirmResetForm>["form"];
  email: string;
};

export const NewPasswordFormSection: FunctionComponent<Props> = ({ form, email }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (email) {
      form.setFieldValue("email", email);
    }
  }, [email, form]);

  return (
    <>
      <form.AppField name="email">
        {() => (
          <AlbInput
            label={t("common.form.input.email")}
            type="TextField"
            variant="filled"
            isEditAllowed={false}
          />
        )}
      </form.AppField>

      <form.AppField name="password">
        {() => (
          <AlbInput
            label={t("common.form.input.new-password")}
            type="TextField"
            variant="filled"
            inputType="password"
            stripSpaces
          />
        )}
      </form.AppField>
      <form.AppField name="confirmPassword">
        {() => (
          <AlbInput
            label={t("common.form.input.confirm-password")}
            type="TextField"
            variant="filled"
            inputType="password"
            stripSpaces
          />
        )}
      </form.AppField>
      <form.Subscribe
        selector={(s) => ({
          password: s.values.password,
          confirmPassword: s.values.confirmPassword,
        })}
      >
        {({ password, confirmPassword }) => (
          <PasswordValidator password={password ?? ""} confirmPassword={confirmPassword ?? ""} />
        )}
      </form.Subscribe>
    </>
  );
};
